import { VueQueryPlugin } from '@tanstack/vue-query'
import { MotionPlugin } from '@vueuse/motion'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { initializeDatadog } from '@/plugins/datadog'

import App from './App/App.vue'
import { AnalyticsPlugin } from './plugins/analytics'
import FeatureFlagsPlugin from './plugins/featureFlags'
import i18n from './plugins/i18n'
import { router } from './router/router'
import store from './store'

import './styles/tailwind.css'
import './styles/main.scss'

const pinia = createPinia()

const app = createApp(App)

initializeDatadog()

app.config.performance = import.meta.env.MODE !== 'production'

app.use(i18n)
app.use(pinia)
app.use(store)
app.use(MotionPlugin)
app.use(VueQueryPlugin)
// Initialize analytics before router to ensure guards can use analytics.track()
app.use(AnalyticsPlugin)

// Initialize feature flags before mounting to ensure guards have access
app.use(FeatureFlagsPlugin)

// Install router last so all dependencies (analytics, feature flags) are ready
app.use(router)

app.mount('#app')
